import React, { Component } from 'react';
import './content-header.css';

export default class ContentHeader extends Component {
  constructor(props) {
    super(props);
  }
  
  render() {
    return (
      <div className="rdp-react-template-component-content-header">
        <span className="rdp-react-template-component-content-header-back" onClick={() => this.props.onBack()}></span>
        <span className="rdp-react-template-component-content-header-title" style={{fontSize: this.props.titleSize || "20px"}}>{this.props.title}</span>
      </div>
    );
  }
}
